import React, { useState, useEffect } from "react";
import axios from "axios";
import "./SearchBar.css";

export const SearchBar = ({
  setResults,
  updateTableData,
  clickedKeywords,
  setClickedKeywords,
}) => {
  const [input, setInput] = useState("");
  const [allData, setAllData] = useState([]);
  const [savedKeywords, setSavedKeywords] = useState([]); // Store saved keywords to send to the backend
  const [value, setValue] = useState("");
  const host = process.env.REACT_APP_HOST;

  // Fetch data when the component mounts
  useEffect(() => {
    axios
      .get(`${host}/keywords`)
      .then((response) => response.data)
      .then((data) => {
        setAllData(data);
      });
  }, []);
  /**This function sets the results displayed under the searchbar
   *
   * @param {*} value
   */
  const handleChange = (value) => {
    setInput(value);
    if (value.length > 0) {
      const results = allData.filter((data) =>
        data.toLowerCase().includes(value.toLowerCase())
      );
      setResults(results);
    } else {
      setResults([]);
    }

    // var input2 = document.getElementById("myInput");
    // input2.addEventListener("keypress", function (event) {
    //   if (event.key === "Enter") {
    //     event.preventDefault();
    //     input2.value = null;
    //   }
    // });
  };

  useEffect(() => {
    const element = document.getElementById("myInput");
    const listener = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        element.value = null;
        handleChange("");
      }
    };

    element.addEventListener("keyup", listener);

    return () => element.removeEventListener("keyup", listener);
  }, []);

  useEffect(() => {
    handleChange("");
  }, [clickedKeywords]);
  /**
   * This functiom takes a keyword and finds it in the array of selected keywords and slices it
   * @param {*} keyword
   */
  const removeTagFromArray = (keyword) => {
    var index = clickedKeywords.indexOf(keyword);
    setClickedKeywords([
      ...clickedKeywords.slice(0, index),
      ...clickedKeywords.slice(index + 1),
    ]);
  };

  // Update savedKeywords whenever clickedKeywords changes
  useEffect(() => {
    setSavedKeywords(clickedKeywords);
  }, [clickedKeywords]);

  return (
    <div className="input-wrapper">
      <div className="clicked-keywords">
        {clickedKeywords.map((keyword, index) => (
          <div key={index} className="keyword">
            {keyword}
            <button
              className="keyword-btn"
              id={keyword}
              onClick={() => removeTagFromArray(keyword)}
            >
              ✕
            </button>
          </div>
        ))}
      </div>
      <input
        placeholder={
          clickedKeywords.length === 0
            ? "Search for cultural sites or keywords..."
            : ""
        }
        value={input}
        id="myInput"
        type="text"
        onChange={(e) => handleChange(e.target.value)}
        // onKeyUp={(event) => newOption(event)}
      />
    </div>
  );
};
